<template>
    <section class="job__tabs tabs">
        <nav class="tabs__navigation">
            <a href="#" class="tabs__link lc-description" :class="{'active': isActive('description') }" @click.prevent="switchTab('description')">
                <icon type="note-text" color="bluegray" size="14" />
                <span class="tabs__link__label">Description</span>
            </a>
            <a v-if="isTablet" href="#" class="tabs__link lc-files" :class="{'active': isActive('files') }" @click.prevent="switchTab('files')">
                <icon type="file" color="bluegray" size="14" />
                <span class="tabs__link__label">Files</span>
            </a>
            <a v-if="isTablet" href="#" class="tabs__link lc-tasks" :class="{'active': isActive('tasks') }" @click.prevent="switchTab('tasks')">
                <icon type="player-list-add" color="bluegray" size="14" />
                <span class="tabs__link__label">Tasks</span>
            </a>
            <a v-if="isTablet" href="#" class="tabs__link lc-time-tracking" :class="{'active': isActive('time-tracking') }" @click.prevent="switchTab('time-tracking')">
                <icon type="timer" color="bluegray" size="14" />
                <span class="tabs__link__label">Time Tracking</span>
            </a>
            <a v-if="isMobile" href="#" class="tabs__link lc-comments" :class="{'active': isActive('comments') }" @click.prevent="switchTab('comments')">
                <icon type="comment-checked" color="bluegray" size="14" />
                <span class="tabs__link__label">Comments</span>
            </a>
        </nav>
        <div class="tabs__body">
            <keep-alive>
                <description v-if="isActive('description')" />
                <files v-if="isTablet && isActive('files')" />
                <tasks v-if="isTablet && isActive('tasks')" />
                <time-tracking v-if="isTablet && isActive('time-tracking')" />
                <comments v-if="isMobile && isActive('comments')" v-keep-scroll-position />
            </keep-alive>
        </div>
    </section>
</template>

<script>
import Device from '../../mixins/deviceAware'
import Description from './Description'
import Files from './Assets'
import Tasks from './Tasks'
import TimeTracking from './TimeTracking'
import Comments from './Comments/Comments'
import Icon from '../Global/Icon'

export default {
    name: 'Tabs',

    mixins: [Device],

    data () {
        return {
            active: 'description'
        }
    },

    watch: {
        screenWidth () {
            if (this.isTablet && this.active === 'comments') {
                this.active = 'description'
            }

            if (this.isMobile && ['files', 'tasks', 'time-trackers'].includes(this.active)) {
                this.active = 'description'
            }
        }
    },

    methods: {
        isActive (tab) {
            return this.active === tab
        },

        switchTab (tab) {
            this.active = tab
        }
    },

    components: {
        Description,
        Tasks,
        Files,
        TimeTracking,
        Comments,
        Icon
    }
}
</script>
